import type { IssueId } from '../../../../../model/issue';
import { toClassName } from '../style-marshal';
import type { ClassName } from '../style-marshal/types';

export const row = (id: IssueId): ClassName => toClassName(`row-${id}`);
export const rowChild = (id: IssueId): ClassName => toClassName(`row-child-${id}`);
